export const userDefaultValues = {
  administrator: false,
  devanner: false,
  manager: false,
};
